<template>
  <div>
    <v-app-bar fixed app color="#262A34" dark>
      <v-app-bar-nav-icon @click.stop="drawer = !drawer" />
      <v-toolbar-title id="text_head" v-text="title"/>
      <v-col>
        <div class='text-right'>
            <v-icon dark color="red" size="35px" @click="GoHome()"> mdi-home-circle-outline </v-icon>
        </div>
      </v-col>
    </v-app-bar>

    <v-navigation-drawer v-model="drawer" bottom app color="#262A34" dark>
      <v-list-item-avatar>
        <v-img
          id="img_vg"
          :src="require('@/assets/LOGO_VGROUP_HONDA_RED.png')"
        ></v-img>
      </v-list-item-avatar>
      <v-list-item
        v-for="(item, i) in menus"
        :key="i"
        :to="item.to"
        router
        exact
      >
        <v-list-item-icon>
          <v-icon v-text="item.icon"></v-icon>
        </v-list-item-icon>

        <v-list-item-title id="title" v-text="item.title"></v-list-item-title>
        <router-link :to="{ query: { ApplicationKey } }"></router-link>
      </v-list-item>
    </v-navigation-drawer>
  </div>
</template>
<script>
export default {
  data: () => ({
    rollHR: false,
    queryStr: '',
    roll: 'emp',
    title: 'HUMAN RESOURCE MANAGEMENT',
    drawer: false,
    menus: []
  }),
  watch: {
    group () {
      this.drawer = false
    }
  },
  async mounted () {
    await this.checkRollHR()
    this.test()
  },
  methods: {
    checkRollHR () {
      if (localStorage.getItem('roll') === 'HR') {
        this.rollHR = true
      }
    },
    test () {
      this.menus = []
      this.menus = [
        {
          title: 'ข้อมูลส่วนตัว',
          icon: 'mdi-account-circle-outline',
          to:
            '/HRM/Employee/EmployeeInfo'
        },
        {
          title: 'ข้อมูลที่อยู่',
          icon: 'mdi-home-circle-outline',
          to:
            '/HRM/Employee/EmployeeAddress'
        },
        {
          title: 'ประวัติครอบครัว',
          icon: 'mdi-account-supervisor-circle-outline',
          to:
            '/HRM/Employee/EmployeeFamily'
        },
        {
          title: 'ประวัติการศึกษา',
          icon: 'mdi-school',
          to:
            '/HRM/Employee/EmployeeEducation'
        },
        {
          title: 'ประสบการณ์ทำงาน',
          icon: 'mdi-briefcase-outline',
          to:
            '/HRM/Employee/EmployeeExperience'
        },
        {
          title: 'ประกันสุขภาพ',
          icon: 'mdi-shield-cross',
          to:
            '/HRM/Employee/EmployeeSso'
        },
        {
          title: 'ประกาศนียบัตร',
          icon: 'mdi-seal-variant',
          to:
            '/HRM/Employee/EmployeeCer'
        },
        {
          title: 'ทักษะด้านภาษา',
          icon: 'mdi-web',
          to:
            '/HRM/Employee/EmployeeLanguageSkill'
        },
        {
          title: 'ทักษะด้านคอมพิวเตอร์',
          icon: 'mdi-monitor-speaker',
          to:
            '/HRM/Employee/EmployeeComputerSkill'
        },
        {
          title: 'ประวัติการทำงาน',
          icon: 'mdi-responsive',
          to:
            '/HRM/Employee/EmployeeJobExperience'
        },
        {
          title: 'แนบไฟล์ (resume)',
          icon: 'mdi-file-document-multiple-outline',
          to:
            '/HRM/Employee/EmployeeUploadFile'
        },
        {
          title: 'นโยบายส่วนตัว',
          icon: 'mdi-book-outline',
          to:
            '/HRM/Employee/EmployeePrivacy'
        },
        {
          title: 'แจ้งปัญหาข้อมูล',
          icon: 'mdi-comment-alert',
          to:
            '/HRM/Employee/EmployeeInfoIssue'
        },
        {
          title: 'ข้อมูลรวม',
          icon: 'mdi-badge-account-horizontal',
          to:
            '/HRM/Employee/EmployeeInfoMerge'
        }
      ]
    },
    GoHome () {
      this.$router.push(localStorage.getItem('Page'))
    }
  }
}
</script>
<style>
#title {
  font-family: Kanit;
  font-weight: 300;
  font-size: 0.8rem;
}
#head_text {
  font-family: Kanit;
  font-size: 0.8rem;
  color: white;
}
#background_card {
  background: #30c42b;
}
#img_vg {
  width: 50px;
  height: 50px;
}
#text_head {
  font-family: Kanit;
}
</style>



// WEBPACK FOOTER //
// src/components/HRM/Employee/EmployeeMenu.vue